import { useUser } from "../contexts/UserContextProvider";

const useApi = () => {
    const [loggedUser] = useUser();
    const returnFunction = async (endpoint, method, body = null, onUnauthorized = () => { }, isJson = true, needsAuth = true, user = loggedUser) => {
        const baseUrl = "/api/";
        let headers = new Headers();
        if (isJson) {
            headers.append("Content-Type", "application/json");
        }
        if (needsAuth && user != null) {
            headers.append("Authorization", `Bearer ${user.accessToken}`);
        }
        let options = {
            method,
            body: body !== null && method !== "GET" ? JSON.stringify(body) : null,
            headers
        };
        if (body instanceof FormData) {
            options.body = body;
        }
        let queryParameters = "";
        if (method === "GET" && body != null) {
            let qp = new URLSearchParams();
            Object.entries(body).forEach((param) => {
                qp.append(param[0], param[1]);
            });
            queryParameters = `?${qp.toString()}`;
        }
        let res = await fetch(`${baseUrl}${endpoint}${queryParameters}`, options);
        if (res.status === 401) {
            try {
                if (typeof onUnauthorized === "function") {
                    onUnauthorized();
                }
                const body401 = await res.clone().json();
                return {
                    ok: false,
                    status: 401,
                    ...body401,
                };
            } catch (e) { }
        }
        if (res.status !== 200 && res.status !== 204) {
            return {
                ok: false,
                status: res.status,
                message: await res.text()
            };
        }
        let json;
        try {
            json = await res.clone().json();
        } catch (e) {
            json = {
                ok: res.status === 200 || res.status === 204,
                status: res.status,
                message: await res.text()
            };
        }
        return json;
    };
    return returnFunction;
};

export default useApi;